import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core'
import {Form} from './core/model/form'
import {Messages} from './core/model/message.model'
import {ConfigService} from './core/service/config.service'
import {MessageService} from './core/service/message.service'

@Component({
  selector: 'fe-form-editor',
  encapsulation: ViewEncapsulation.None,
  template: `
    <fe-form (changed)="changed.emit($event)"></fe-form>
  `,
})
export class FormEditorComponent implements OnInit {

  @Input() baseUrl: string

  @Input() formId: string

  @Input() weights: string[] | number[]

  @Input() messages: Messages

  @Output() changed: EventEmitter<Form> = new EventEmitter()

  @Output() errorCallback: EventEmitter<string> = new EventEmitter()

  constructor(private config: ConfigService,
              private message: MessageService) {
  }

  ngOnInit() {
    this.config.init({
      baseUrl: this.baseUrl,
      formId: this.formId,
      weights: this.weights,
      onChange: this.changed.emit,
      errorCallback: this.errorCallback.emit,
    })
    this.message.init(this.messages)
  }
}
